import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-4 pb-4 pt-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-textPrimary mb-4 text-left" }, " Selecione um modelo para importar as configurações ", -1)
const _hoisted_3 = { class: "max-h-[320px] overflow-y-auto flex flex-col gap-2 relative" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 bg-white/60 z-10 flex items-center justify-center"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold text-textPrimary" }, "Nome", -1)
const _hoisted_8 = { class: "text-textPrimary" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "text-sm text-gray-500 text-center py-6"
}

import { ref, computed } from 'vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import RadioButton from '@/components/designSystem/RadioButton/index.vue'
import DeleteIcon from '@/assets/icons/delete.vue'
import Spinner from '@/components/others/Spinner.vue'
import type { ApprovalFlowTemplateDetail } from '@/Network/Types/Responses/ApprovalFlowTemplateResponses'

interface ConfigTemplate {
  id: number
  name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigTemplateTab',
  props: {
    modelValue: {},
    savedTemplate: {},
    templates: {},
    isDeleting: { type: Boolean }
  },
  emits: ["update:modelValue", "delete"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





const searchQuery = ref('')

const templateList = computed<ConfigTemplate[]>(() => {
  const base: ConfigTemplate[] = (props.templates ?? []).map((t) => ({
    id: t.id,
    name: t.name
  }))
  if (props.savedTemplate && !base.find((t) => t.id === props.savedTemplate!.id)) {
    return [props.savedTemplate, ...base]
  }
  return base
})

const filteredTemplates = computed(() => {
  if (!searchQuery.value) return templateList.value
  const q = searchQuery.value.toLowerCase()
  return templateList.value.filter((t) => t.name.toLowerCase().includes(q))
})

const handleSearch = async () => {
  // filtro local via computed — sem necessidade de chamada extra
}

const handleDelete = (id: number) => {
  emit('delete', id)
}

const removeTemplate = () => {
  emit('update:modelValue', null)
}

__expose({ removeTemplate })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(SearchInput, {
      modelValue: searchQuery.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
      label: "Buscar unidades ou escalas",
      placeholder: "Digite o nome da unidade ou escala",
      "persistent-placeholder": "",
      "search-function": handleSearch
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isDeleting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(Spinner, {
              color: "primary",
              size: "3rem"
            })
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTemplates.value, (template) => {
        return (_openBlock(), _createElementBlock("div", {
          key: template.id,
          class: _normalizeClass(["flex items-center justify-between rounded-lg px-4 py-3 cursor-pointer transition-colors", 
          _ctx.modelValue === template.id
            ? 'bg-[#E8F4F7] border border-primary'
            : 'bg-[#F0F0F4] hover:bg-gray-200'
        ]),
          onClick: ($event: any) => (_ctx.$emit('update:modelValue', template.id))
        }, [
          _createVNode(RadioButton, {
            id: `template-${template.id}`,
            name: "config-template",
            value: template.id,
            "model-value": _ctx.modelValue ?? '',
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', Number($event))))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, _toDisplayString(template.name), 1)
              ])
            ]),
            _: 2
          }, 1032, ["id", "value", "model-value"]),
          _createElementVNode("button", {
            class: "p-1 rounded hover:bg-red-50 transition-colors",
            onClick: _withModifiers(($event: any) => (handleDelete(template.id)), ["stop"])
          }, [
            _createVNode(DeleteIcon, {
              color: "#C62828",
              width: "24",
              height: "24"
            })
          ], 8, _hoisted_9)
        ], 10, _hoisted_5))
      }), 128)),
      (filteredTemplates.value.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Nenhum modelo encontrado "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})